export enum DocumentType {
  KTP = "KTP",
  NPWP_COMPANY = "NPWP Company",
  NPWP_INDIVIDU = "NPWP Individu",
  REKENING_KORAN = "Rekening Koran",
  FAKTUR_PAJAK = "Faktur Pajak",
  INVOICE = "Invoice",
  DOKUMEN_PO = "Dokumen PO",
}

export enum DocumentStatus {
  PENDING = "PENDING",
  PROCESSED = "PROCESSED",
  FAILED = "FAILED",
}

export enum ForgeryStatus {
  CLEAN = "CLEAN",
  FORGED = "FORGED",
  UNDETERMINED = "UNDETERMINED",
}

export enum ForgeryCheckType {
  LOGICAL_FLAW = "Logical Flaw",
  IMAGE_ANOMALY = "Image Anomaly",
  METADATA_CHECK = "Metadata Check",
  FORMAT_INCONSISTENCY = "Format Inconsistency",
}

export interface ForgeryCheckResult {
  type: ForgeryCheckType;
  passed: boolean;
  verified: boolean;
  details: string;
  subChecks?: string[];
}

export interface ForgeryResult {
  status: ForgeryStatus;
  message: string;
  checks: ForgeryCheckResult[];
}

export type JSONPrimitive = string | number | boolean | null;
export type JSONArray = JSONValue[];
export type JSONObject = { [key: string]: JSONValue };
export type JSONValue = JSONPrimitive | JSONArray | JSONObject;

export interface UploadedDocument {
  id: string;
  type: DocumentType;
  fileName: string;
  fileSize: number;
  fileUrl: string;
  uploadDate: Date;
  companyName: string;
  status: DocumentStatus;
  filePath: string;
}

export interface KTPData {
  provinsi?: string;
  kotaKabupaten?: string;
  nik: string;
  nama: string;
  tempatTglLahir: string;
  jenisKelamin: string;
  golDarah?: string;
  alamat: string;
  rtRw: string;
  kelDesa: string;
  kecamatan: string;
  agama: string;
  statusPerkawinan: string;
  pekerjaan: string;
  kewarganegaraan: string;
  berlakuHingga: string;
}

export interface NPWPData {
  nomorNPWP: string;
  nama: string;
  nik?: string;
  alamat: string;
  kppPenerbit?: string;
  tanggalTerdaftar?: string;
}

export interface RekeningKoranTransaction {
  tanggal: string;
  keterangan: string;
  cbg?: string;
  mutasi: string;
  saldo: string;
}

export interface RekeningKoranData {
  bankName: string;
  accountName: string;
  address: string;
  accountNumber: string;
  period: string;
  currency: string;
  tableData?: RekeningKoranTransaction[];
}

export interface InvoiceData {
  invoiceNo: string;
  invoiceIssueDate: string;
  invoiceDueDate: string;
  customer: string;
  alamatCustomer?: string;
  namaProduk: string;
  quantity: string;
  unitPrice: string;
  amount: string;
  total: string;
  totalTerbilang?: string;
  ppnVat?: string;
  discount?: string;
}

export interface FakturPajakTableRow {
  no?: string;
  namaBarangKenaPajak: string;
  hargaJualPenggantian: string;
}

export interface FakturPajakData {
  kodeDanNomorSeriFakturPajak: string;
  namaPengusahaKenaPajak: string;
  alamatPengusahaKenaPajak: string;
  npwpPengusahaKenaPajak: string;
  namaPembeliBarangKenaPajak: string;
  alamatPembeliBarangKenaPajak: string;
  npwpPembeliBarangKenaPajak: string;
  kodeBarangJasa?: string;
  namaBarangKenaPajak?: string;
  hargaJualPenggantian?: string;
  dikurangiPotonganHarga?: string;
  dikurangiUangMuka?: string;
  dasarPengenaanPajak?: string;
  jumlahPPN?: string;
  jumlahPPnBM?: string;
  tableData?: FakturPajakTableRow[];
}

export type DocumentData =
  | KTPData
  | NPWPData
  | RekeningKoranData
  | InvoiceData
  | FakturPajakData;
